"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _clsx2 = _interopRequireDefault(require("clsx"));

var _reactI18next = require("react-i18next");

var _LoadMore = _interopRequireDefault(require("../LoadMore"));

var _excluded = ["options", "inputValue", "onInputChange", "onChange", "placeholder", "isRequesting", "canLoadMore", "onLoadMore", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'BrandAutocomplete';
var classes = {
  highlighted: "".concat(PREFIX, "-highlighted")
};
var CustomPaper = (0, _styles.styled)(_material.Paper)(function (_ref) {
  var theme = _ref.theme;
  return {
    background: theme.palette.table.filter.secondary,
    '.MuiAutocomplete-noOptions': {
      padding: '5px 5px'
    }
  };
});
var LoadingOption = (0, _styles.styled)(_material.MenuItem)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    background: theme.palette.table.filter.secondary,
    opacity: '1 !important'
  };
});
var NoOptions = (0, _styles.styled)(_material.MenuItem)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    background: theme.palette.table.filter.secondary
  };
});
var MenuOption = (0, _styles.styled)(_material.MenuItem)(function (_ref4) {
  var theme = _ref4.theme;
  return _defineProperty({
    p: _defineProperty({
      width: '90%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: '1rem !important'
    }, theme.breakpoints.down('sm'), {
      fontSize: '0.875rem !important'
    })
  }, "&.".concat(classes.highlighted), {
    background: theme.palette.table.selected.background.primary
  });
});
var NoOptionsTypography = (0, _styles.styled)(_material.Typography)(function (_ref6) {
  var theme = _ref6.theme;
  return _defineProperty({
    fontSize: '1rem !important'
  }, theme.breakpoints.down('sm'), {
    fontSize: '0.875rem !important'
  });
});
var StyledTextField = (0, _styles.styled)(_material.TextField)(function (_ref8) {
  var theme = _ref8.theme;
  return {
    'div > input': _defineProperty({
      fontSize: '1rem !important'
    }, theme.breakpoints.down('sm'), {
      fontSize: '0.875rem !important'
    })
  };
});
var StyledAutocomplete = (0, _styles.styled)(_material.Autocomplete)(function (_ref9) {
  var theme = _ref9.theme;
  return {
    borderRadius: '4px',
    '& .MuiFormControl-root': {
      label: {
        color: theme.palette.font.primary,
        opacity: 0.6
      },
      '.MuiOutlinedInput-root > .MuiAutocomplete-endAdornment > button': {
        color: theme.palette.font.primary
      },
      '.MuiOutlinedInput-root > .MuiAutocomplete-endAdornment': {
        top: 'auto'
      }
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-disabled': {
        opacity: 0.6,
        fieldset: {
          border: "1px solid ".concat(theme.palette.font.primary)
        },
        '&:hover': {
          fieldset: {
            border: "1px solid ".concat(theme.palette.font.primary)
          }
        },
        input: {
          WebkitTextFillColor: "".concat(theme.palette.font.primary, " !important"),
          color: "".concat(theme.palette.font.primary, " !important")
        }
      },
      '&:hover': {
        fieldset: {
          border: "2px solid ".concat(theme.palette.font.primary)
        }
      },
      fieldset: {
        height: '100%',
        top: '0px',
        border: "1px solid ".concat(theme.palette.font.primary),
        legend: {
          display: 'none'
        }
      }
    }
  };
});

var BrandAutocomplete = function BrandAutocomplete(_ref10) {
  var _ref10$options = _ref10.options,
      options = _ref10$options === void 0 ? [] : _ref10$options,
      inputValue = _ref10.inputValue,
      onInputChange = _ref10.onInputChange,
      onChange = _ref10.onChange,
      placeholder = _ref10.placeholder,
      isRequesting = _ref10.isRequesting,
      canLoadMore = _ref10.canLoadMore,
      onLoadMore = _ref10.onLoadMore,
      value = _ref10.value,
      props = _objectWithoutProperties(_ref10, _excluded);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(StyledAutocomplete, _extends({
    PaperComponent: CustomPaper,
    options: options,
    onChange: onChange,
    onInputChange: onInputChange,
    filterOptions: function filterOptions(x) {
      return x;
    },
    value: value,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(StyledTextField, _extends({}, params, {
        inputProps: _objectSpread(_objectSpread({
          className: classes.formControl
        }, params.inputProps), {}, {
          'aria-label': 'autocomplete-search-input'
        }),
        InputLabelProps: {
          className: classes.formControl
        },
        size: "small",
        placeholder: placeholder || t('search'),
        fullWidth: true
      }));
    },
    renderOption: function renderOption(optionProps, option) {
      var renderedItem = [/*#__PURE__*/_react.default.createElement(MenuOption, _extends({
        className: (0, _clsx2.default)(_defineProperty({}, classes.highlighted, (value === null || value === void 0 ? void 0 : value.value) === option.value)),
        key: option.value
      }, optionProps), /*#__PURE__*/_react.default.createElement(_material.Typography, null, option.label))];

      if (optionProps['data-option-index'] === options.length - 1 && isRequesting && canLoadMore) {
        renderedItem.push( /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
          disabled: true,
          "aria-label": "loading-more",
          role: "option",
          key: "loader",
          sx: {
            display: 'flex',
            justifyContent: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
          size: 20
        })));
      }

      if (optionProps['data-option-index'] === options.length - 1 && !isRequesting && canLoadMore) {
        renderedItem.push( /*#__PURE__*/_react.default.createElement(_LoadMore.default, {
          key: "load-more",
          onLoadMore: onLoadMore,
          isRequesting: isRequesting
        }));
      }

      return renderedItem;
    },
    noOptionsText: isRequesting ? /*#__PURE__*/_react.default.createElement(LoadingOption, {
      disabled: true,
      key: "loader",
      sx: {
        display: 'flex',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
      size: 20
    })) : /*#__PURE__*/_react.default.createElement(NoOptions, null, /*#__PURE__*/_react.default.createElement(NoOptionsTypography, {
      color: "secondary"
    }, "No Options"))
  }, props));
};

var _default = BrandAutocomplete;
exports.default = _default;